import { useDispatch } from 'react-redux';
import { normalizeFullSchedulePayload, replaceRealtimeSchedule } from '../redux/slices/jobScheduleSlice';
import { setTbdList } from '../redux/slices/tbdApiSlice';
import { setPumpDetails } from '../redux/slices/pumpDetailsSlice';
import { setSellPricesFromRecords } from '../redux/slices/sellPriceSlice';
import { setChangeOrderDetails } from '../redux/slices/changeOrderDetailsSlice';
import useScheduleRealtime from './useScheduleRealtime';

// Both containers publish the same aggregate snapshot into shared Redux data.
export default function useSharedScheduleRealtime({ enabled = true, blocked = false } = {}) {
  const dispatch = useDispatch();
  useScheduleRealtime({ enabled, blocked,
    additionalResources: ['portal:pump-details', 'portal:change-order-details', 'portal:change-order-parent', 'portal:tbd-finder'],
    apply: (rows, snapshots) => {
      const data = normalizeFullSchedulePayload(snapshots[0].core);
      dispatch(replaceRealtimeSchedule(rows));
      dispatch(setTbdList(data.tbdList));
      dispatch(setPumpDetails(data.pumpDetails));
      dispatch(setSellPricesFromRecords(data.soldToShipTo));
      dispatch(setChangeOrderDetails(data.changeOrderDetails));
    },
  });
}
